import React from 'react'
import { Container } from 'react-bootstrap';

const NewsDesc = () => {
    return (<>

        <Container className="outerContainer">
            <h1 className="mb-4 centerText" >News</h1>
            <p className="lead centerText">This page includes announcements related to software updates, Federal Register notices and other pertinent updates for AHRQ QI users.</p>
        </Container>
      
    </>)
}

export default NewsDesc;